export default function configs(state = false, action){
    switch(action.type){
        case "ALTERARMENU":
            return action.configs;

        default:
            return state;
    }
}